import React, { useMemo, useCallback } from 'react';

import without from 'lodash/without';

import { MultiSelect, Button, Picker as UIPicker } from '@gogame/components';

export const RewardsPicker = ({
  options,
  error,
  value = [],
  disabled,
  onChange,
  loading,
}) => {
  const selectValue = useMemo(() => value.map(({ id }) => id), [value]);

  const handleSelectChange = useCallback(
    (e, v) => {
      const ids = without(v, ...selectValue);

      onChange(
        e,
        options.filter((o) => ids.includes(o.id))
      );
    },
    [selectValue, options]
  );

  return (
    <MultiSelect
      withSelectAll={false}
      options={options}
      value={selectValue}
      hideSelectedOption={true}
      onChange={handleSelectChange}
      error={error}
      disabled={disabled}
      label={'Rewards'}
      required={true}
      loading={loading}
      name={'rewards'}
    />
  );
};

export const ConditionsPicker = ({ onChange, options, disabled, loading }) => {
  const handleChange = (condition) => onChange(condition);

  return (
    <UIPicker
      button={
        <Button add={true} variant={'outlined'} loading={loading}>
          Condition
        </Button>
      }
      onChange={handleChange}
      options={options}
      disabled={disabled}
    />
  );
};
